import * as THREE from 'three';

export default class ScreenPositionUtil {
  /*
  3D >> 2D 変換
  値は Vector2 で返す。
  対象オブジェクトがカメラの表示範囲外の時は { x: -1, y: -1 } を返す。
  */
  public isTargetable(target: any, obj : any): boolean {
    if (!target) return true;
    if (target === obj) return true;
    // console.log(target.name);
    if (target.name.match(/(wall)|(kosi)|(door)|(sash)|(kaidan)|(ent)/)) return false; // 壁窓扉等
    return this.isTargetable(target.parent, obj);
  }

private checkFrustum(camera: THREE.Camera, object: THREE.Object3D) {
     camera.updateMatrix(); // make sure camera's local matrix is updated
     camera.updateMatrixWorld(); // make sure camera's world matrix is updated
     // camera.matrixWorldInverse.getInverse( camera.matrixWorld );

     object.updateMatrix();      // make sure object's local matrix is updated
     object.updateMatrixWorld(); // make sure object's world matrix is updated

     const frustum = new THREE.Frustum();
     frustum.setFromProjectionMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));
     const bbox = new THREE.Box3().setFromObject(object);
     const center = bbox.getCenter(new THREE.Vector3());
     return frustum.containsPoint(center);
}

  public toScreenPosition(size: THREE.Vector2, offset: THREE.Vector2, obj: any, camera: THREE.Camera, target: any) {
    // 画角内に形状があるか
    if (this.checkFrustum(camera, obj) == false) {
        return { x: -100, y: -100 };
    }

    const camPos = camera.getWorldPosition(new THREE.Vector3());
    const objPos = obj.getWorldPosition(new THREE.Vector3());
    const dir = objPos.clone().sub(camPos);                     //カメラから形状までのベクトル
    const dist = dir.length();                                  //カメラから形状までの距離

    // 壁越しの形状は拾わない.
    dir.normalize();
    const rayY: THREE.Raycaster = new THREE.Raycaster(camPos, dir);
    const objsY: THREE.Intersection[] = rayY.intersectObjects(target, true);
    if (objsY.length > 0) {
      for (let i = 0; i < objsY.length; i += 1) {
        if ((objsY[i].object instanceof THREE.LineSegments)) continue;
        if (objsY[i].distance >= dist) break;
        if (!this.isTargetable(objsY[i].object, obj)) {
            return { x: -100, y: -100 };
        }
      }
    }
    // 変換
    const v = new THREE.Vector3();

    const widthHalf: number = size.width * 0.5; // 0.5* renderer.context.canvas.width;
    const heightHalf: number = size.height * 0.5; // 0.5* renderer.context.canvas.height;

    v.setFromMatrixPosition(obj.matrixWorld);
    v.project(camera);

    v.x = (v.x * widthHalf) + widthHalf;
    v.y = -(v.y * heightHalf) + heightHalf;

    return { x: v.x + offset.x, y: v.y + offset.y };
  }

  public ScreenCoordinates(size: THREE.Vector2, object: any, camera: THREE.Camera, target: any) {
    // 画角内に形状があるか
    if (this.checkFrustum(camera, object) == false) {
        return { x: -100, y: -100 };
    }

    const camPos = camera.getWorldPosition(new THREE.Vector3());

    const bbox = new THREE.Box3().setFromObject(object);
    const center = bbox.getCenter(new THREE.Vector3());

    const dir = center.clone().sub(camPos);                     //カメラから形状までのベクトル
    const dist = dir.length();                                  //カメラから形状までの距離

    // 壁越しの形状は拾わない.
    dir.normalize();
    const rayY: THREE.Raycaster = new THREE.Raycaster(camPos, dir);
    const objsY: THREE.Intersection[] = rayY.intersectObjects(target, true);
    if (objsY.length > 0) {
      for (let i = 0; i < objsY.length; i += 1) {
        if ((objsY[i].object instanceof THREE.LineSegments)) continue;
        if (objsY[i].distance >= dist) break;
        if (!this.isTargetable(objsY[i].object, object)) {
            return { x: -100, y: -100 };
        }
      }
    }

    const projection = center.project(camera);

    const sx = (size.x / 2) * (+projection.x + 1.0);
    const sy = (size.y / 2) * (-projection.y + 1.0);
    return { x: sx, y: sy };
  }

  public ScreenCoordinatesFromPoint(size: THREE.Vector2, object: THREE.Object3D, point: THREE.Vector3, camera: THREE.Camera, target: any) {
    // 画角内に形状があるか
    if (this.checkFrustum(camera, object) == false) {
        return { x: -100, y: -100 };
    }

    const camPos = camera.getWorldPosition(new THREE.Vector3());

    const bbox = new THREE.Box3().setFromObject(object);
    const center = bbox.getCenter(new THREE.Vector3());

    const dir = center.clone().sub(camPos);                     //カメラから形状までのベクトル
    const dist = dir.length();                                  //カメラから形状までの距離

    // 壁越しの形状は拾わない.
    dir.normalize();
    const rayY: THREE.Raycaster = new THREE.Raycaster(camPos, dir);
    const objsY: THREE.Intersection[] = rayY.intersectObjects(target, true);
    if (objsY.length > 0) {
      for (let i = 0; i < objsY.length; i += 1) {
        if ((objsY[i].object instanceof THREE.LineSegments)) continue;
        if (objsY[i].distance >= dist) break;
        if (!this.isTargetable(objsY[i].object, object)) {
            return { x: -100, y: -100 };
        }
      }
    }

    const projection = point.clone().project(camera);

    const sx = (size.x / 2) * (+projection.x + 1.0);
    const sy = (size.y / 2) * (-projection.y + 1.0);
    return { x: sx, y: sy };
  }


  public calcDeletePicker(canvasSize: THREE.Vector2, object: any, camera: THREE.Camera, target: any) {
    // 画角内に形状があるか
    if (this.checkFrustum(camera, object) == false) {
        return { x: -100, y: -100 };
    }

    const camPos = camera.getWorldPosition(new THREE.Vector3());

    const bbox = new THREE.Box3().setFromObject(object);
    const center = bbox.getCenter(new THREE.Vector3());

    const dir = center.clone().sub(camPos);                     //カメラから形状までのベクトル
    const dist = dir.length();                                  //カメラから形状までの距離

    // 壁越しの形状は拾わない.
    dir.normalize();
    const rayY: THREE.Raycaster = new THREE.Raycaster(camPos, dir);
    const objsY: THREE.Intersection[] = rayY.intersectObjects(target, true);
    if (objsY.length > 0) {
      for (let i = 0; i < objsY.length; i += 1) {
        if ((objsY[i].object instanceof THREE.LineSegments)) continue;
        if (objsY[i].distance >= dist) break;
        if (!this.isTargetable(objsY[i].object, object)) {
            return { x: -100, y: -100 };
        }
      }
    }

    const projection = (p: THREE.Vector3) => {
        const prj = p.project(camera);
        const sx = (canvasSize.x / 2) * (+prj.x + 1.0);
        const sy = (canvasSize.y / 2) * (-prj.y + 1.0);
        return new THREE.Vector2(sx, sy);
    }
    // camera
    const v1 = center.clone().sub(camPos);
    const v2 = v1.cross(new THREE.Vector3(0,1,0)).normalize();

    const points = [
        new THREE.Vector3(bbox.min.x, bbox.min.y, bbox.min.z),
        new THREE.Vector3(bbox.max.x, bbox.min.y, bbox.min.z),
        new THREE.Vector3(bbox.max.x, bbox.min.y, bbox.max.z),
        new THREE.Vector3(bbox.min.x, bbox.min.y, bbox.max.z)
    ];
    const scaler = points.map(p => v2.dot(p));

    const index = scaler.indexOf(Math.max(...scaler));
    const v = projection(points[index]);
    return {x: v.x, y: v.y};

    // bboxの８点から2Dの資格領域を算出
    // const point = [];
    // point.push(projection(new THREE.Vector3(bbox.min.x, bbox.min.y, bbox.min.z)));
    // point.push(projection(new THREE.Vector3(bbox.max.x, bbox.min.y, bbox.min.z)));
    // point.push(projection(new THREE.Vector3(bbox.max.x, bbox.min.y, bbox.max.z)));
    // point.push(projection(new THREE.Vector3(bbox.min.x, bbox.min.y, bbox.max.z)));
    // point.push(projection(new THREE.Vector3(bbox.min.x, bbox.max.y, bbox.min.z)));
    // point.push(projection(new THREE.Vector3(bbox.max.x, bbox.max.y, bbox.min.z)));
    // point.push(projection(new THREE.Vector3(bbox.max.x, bbox.max.y, bbox.max.z)));
    // point.push(projection(new THREE.Vector3(bbox.min.x, bbox.max.y, bbox.max.z)));

    // const box2 = new THREE.Box2().setFromPoints(point);

    // return { x: box2.max.x, y: box2.max.y};
  }
}
